import BaseModel from "~/models/BaseModel";

export default class UserColumnModel extends BaseModel {}
